import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonGroup from './ButtonGroup'; // btn类型

var typeClass = {
  normal: 'roo-btn-primary',
  hollow: 'roo-btn-default',
  weaken: 'roo-btn-default roo-btn-weaken',
  dashed: 'roo-btn-default roo-btn-dashed',
  text: 'roo-btn-link',
  brand: 'roo-btn-brand',
  'brand-hollow': 'roo-btn-outline-brand',
  'brand-text': 'roo-btn-link roo-btn-link-brand'
};
var sizeClass = {
  large: 'roo-btn-lg',
  small: 'roo-btn-sm',
  mini: 'roo-btn-xs',
  normal: ''
}; // button总体样式

function btnClassName(props) {
  var _classNames;

  var type = props.type,
      size = props.size,
      disabled = props.disabled,
      auto = props.auto,
      status = props.status,
      autoFocus = props.autoFocus,
      className = props.className,
      block = props.block;
  return classNames('roo-btn', typeClass[type || 'normal'], sizeClass[size || 'normal'], (_classNames = {
    disabled: disabled,
    'roo-btn-block': block,
    'roo-btn-stable': !auto
  }, _defineProperty(_classNames, "roo-btn-".concat(status), status), _defineProperty(_classNames, "focus", autoFocus), _classNames), className);
} // icon图标样式


function renderIcon(props) {
  if (props.loading) {
    return /*#__PURE__*/React.createElement("i", {
      className: "roo-icon roo-icon-loading ani-spin"
    });
  } else {
    return props.icon ? /*#__PURE__*/React.createElement("i", {
      className: "roo-icon roo-icon-".concat(props.icon)
    }) : null;
  }
} // TODO: when <a> disabled, preventing event


var Button = function Button(_a) {
  var children = _a.children,
      restProps = __rest(_a, ["children"]);

  var autoFocus = restProps.autoFocus,
      loading = restProps.loading,
      auto = restProps.auto,
      type = restProps.type,
      status = restProps.status,
      icon = restProps.icon,
      href = restProps.href,
      disabled = restProps.disabled,
      htmlType = restProps.htmlType,
      block = restProps.block,
      className = restProps.className,
      style = restProps.style,
      otherProps = __rest(restProps, ["autoFocus", "loading", "auto", "type", "status", "icon", "href", "disabled", "htmlType", "block", "className", "style"]);
  /* eslint-disable react/button-has-type */


  return restProps.href ? /*#__PURE__*/React.createElement("a", _Object$assign({}, otherProps, {
    href: href,
    className: btnClassName(restProps),
    style: style
  }), renderIcon(restProps), children) : /*#__PURE__*/React.createElement("button", _Object$assign({}, otherProps, {
    disabled: loading || disabled,
    type: htmlType,
    className: btnClassName(restProps),
    style: style
  }), renderIcon(restProps), children);
  /* eslint-enable react/button-has-type */
};

Button.defaultProps = {
  htmlType: 'button',
  type: 'normal',
  size: 'normal',
  auto: true,
  loading: false,
  disabled: false,
  autoFocus: false,
  icon: '',
  status: 'normal',
  href: '',
  block: false
};
Button.propTypes = {
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  type: PropTypes.oneOf(['normal', 'hollow', 'weaken', 'dashed', 'text', 'brand', 'brand-hollow', 'brand-text']),
  size: PropTypes.oneOf(['large', 'normal', 'small', 'mini']),
  auto: PropTypes.bool,
  loading: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'danger', 'info', 'warning', 'normal']),
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  href: PropTypes.string,
  autoFocus: PropTypes.bool,
  block: PropTypes.bool
};
Button.Group = ButtonGroup;
export default Button;